export const FEATURE_FLAGS = {
  CHATBOT_ENABLED: 'chatbot-enabled',
  MY_SSS: 'mysss_enabled',
} as const;

export const FEATURE_FLAG_ATTRIBUTES = {
  CHAT_SEGMENT: 'chatSegment',
} as const;

export const CHAT_SEGMENTS = {
  NEW_USER: 'NEW_USER',
  SME: 'SME',
  KA_OR_MIXED: 'KA_OR_MIXED',
} as const;

export type ChatSegment = (typeof CHAT_SEGMENTS)[keyof typeof CHAT_SEGMENTS];

export type FeatureFlagArgs = Partial<
  Record<keyof typeof FEATURE_FLAGS, boolean>
>;
